//混入的实例可配置的
// data:SearchData
// methods: HandleCommand+XXX,例如HandleCommandOnline
// SubmitPublish
import TableOperation from "@/components/gadget/TableOperation";
import { l, GetResourceUrl } from "@/assets/js/i18n.js";
export default {
  components: { TableOperation },
  data() {
    return {
      //弹窗相关
      ShowCreateOrEditDialog: false,

      //表格相关
      GetTableListWhenMounted: true,
      CurrentPage: 1,
      PageSize: 10,
      PageSizeList: [10, 20, 50, 100],
      Sorting: null,
      TotalCount: undefined,
      TableList: [],
      SearchData: {},
      MultipleSelection: [],

      ScrollAfterChange: true,

      //发布相关
      DrawerVisible: false,
      PublishTreeData: [],
      PublishTreeProps: {
        children: "children",
        label: "label"
      },

    }
  },
  mounted() {

    //处理完自身的mounted之后再执行以下内容（自身不用created是为了方便操作子组件）
    if (this.GetTableListWhenMounted) {
      this.$nextTick(() => {
        this.GetTableList(true);
      })
    }
  },
  methods: {
    IndexMethod(index) {
      return (this.CurrentPage - 1) * this.PageSize + index + 1;
    },
    GetTableList() {
      console.log('GetTableList')
    },
    HandleSizeChange(val) {
      this.PageSize = val;
      this.GetTableList(true);
    },
    HandleCurrentChange(val) {
      if (this.ScrollAfterChange) {
        try {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        } catch (error) {
          console.log("error", error)
        }
      }

      this.CurrentPage = val;
      this.GetTableList();
    },
    HandleSelectionChange(val) {
      // console.log("HandleSelectionChange",val)
      this.MultipleSelection = val;
    },
    HandleCommand(command) {
      this['HandleCommand' + command.replace(command[0], command[0].toUpperCase())]();
    },
    CheckSelection() {
      return new Promise((resolve, reject) => {
        if (this.MultipleSelection.length > 0) {
          resolve(this._.cloneDeep(this.MultipleSelection));
        } else {
          this.$message({
            message: l('请至少勾选一项进行操作'),
            type: 'warning'
          });
          reject();
        }
      })
    },
    HandleCommandPublish() {
      this.CheckSelection().then(r => {
        this.DrawerVisible = true;
        console.log(r);
      })
    },
    SubmitPublish() {
      var nodes = this.$refs.PublishTree.getCheckedNodes();
      // var nodes=this.$refs.PublishTree.getCheckedKeys();
      console.log(nodes);
    },
    ViewItem(item) {
      this.$refs.createOrEditDialog.Type = "View";
      this.$refs.createOrEditDialog.Show(item);
    },
    CreateItem(item) {//调用者如果不传会默认传入点击事件
      this.$refs.createOrEditDialog.Type = "Create";
      this.$refs.createOrEditDialog.Show(item);
    },
    EditItem(item) {
      this.$refs.createOrEditDialog.Type = "Edit";
      this.$refs.createOrEditDialog.Show(item);
    },
    DeleteItem() {/* ... */ },
    HandleSortChange(e) {
      console.log(e)
      if (e.order) {
        if (e.order == "descending") {
          this.Sorting = "-" + e.prop;
        } else if (e.order == "ascending") {
          this.Sorting = e.prop;
        }
      } else {
        this.Sorting = null;
      }
      this.GetTableList(true);
    },

    HandleOperation({ command, row }) {
      this[command](row);
    },
  }

};
